import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "首页",
    component: () => import("@/views/index.vue"),
  },
  {
    path: "/downloadApp",
    name: "下载APP",
    component: () =>
      import("@/views/DownloadApp.vue"),
  },
];

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes,
});

export default router;
